import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function BorderVerticalIcon(props: IconProps) {
    return <Icon {...props} iconKey={"border_vertical"}/>
}
